import { OrderMarketTypeEnum } from '../../enum/orders/market-type.enum';
import { SecurityCategory } from '../../enum/security-category.enum';
import { IStressResponse } from '../../interfaces/pos-risk/stress.interface';

export class InstrumentLite {

    public description: string;
    public quoteFactor: number;
    public unitPrice: number;
    public standardLot: number;
    public stress: IStressResponse;
    public logoPath: string;
    public typeMarket: OrderMarketTypeEnum;
    public active: string;
    public variation: number;
    public rangeMinimumPriceIncrements: number;
    public dateTimeLastTrade: string;
    public securityCategory: SecurityCategory;
    public brokerageFactor: number;

    constructor(response) {
        this.active = response.active;
        this.description = response.description || response.descriptionStock;
        this.quoteFactor = response.quoteFactor;
        this.unitPrice = response.unitPrice;
        this.standardLot = response.standartLot || response.standardLot;
        this.stress = response.stress;
        this.logoPath = response.logoPath;
        this.typeMarket = response.typeMarket;
        this.variation = response.variation || 0;
        this.rangeMinimumPriceIncrements = +response.rangeMinimumPriceIncrements;
        this.dateTimeLastTrade = response.dateTimeLastTrade;
        this.brokerageFactor = response.brokerageFactor;
    }

    /**
     * Gerar mock para o Instrument Lite
     * @param {string} symbol Código do ativo.
     * @param {price} price Preço do ativo.
     * @param {OrderMarketTypeEnum} typeMarketMock Tipo do ativo.
     */
    public static getMock(symbol: string, price: number, typeMarketMock: OrderMarketTypeEnum): InstrumentLite {
        return {
            active: symbol,
            brokerageFactor: 1,
            dateTimeLastTrade: '',
            description: '',
            logoPath: '',
            quoteFactor: 1,
            rangeMinimumPriceIncrements: 1,
            securityCategory: SecurityCategory.Undefined,
            standardLot: 100,
            stress: {
                dayTradeStrategyValue: 2,
                dayTradeValue: 1,
                isPtax: false,
                value: 100,
            },
            typeMarket: typeMarketMock,
            unitPrice: price,
            variation: 1,
        };
    }

}
